module.exports = __webpack_public_path__ + "images/park-west-f6f1754debedb8449f554dc6065ab787.jpg";